import API from '../apiClient';

/*
 * Signup source codes (marketing/partner signup links + funnel tracking).
 *
 * Public endpoints (no auth) used by the pre-auth signup page:
 *  - resolveSignupCode: look up a URL code (e.g. SAIA) -> onboarding route + personalization
 *  - recordSignupCodeClick: count one signup-link visit (refresh-safe via correlation_id)
 *
 * Tech Admin endpoints power the System > Signup Codes screen.
 */

export const resolveSignupCode = (code) =>
  API.get(`/signup-codes/resolve?code=${encodeURIComponent(code)}`);

export const recordSignupCodeClick = (payload) =>
  API.post(`/signup-codes/click`, payload);

export const listSignupCodes = (search = "") =>
  API.get(`/signup-codes/${search ? `?search=${encodeURIComponent(search)}` : ""}`);

export const createSignupCode = (payload) =>
  API.post(`/signup-codes/`, payload);

export const updateSignupCode = (id, payload) =>
  API.put(`/signup-codes/${encodeURIComponent(id)}`, payload);

export const deleteSignupCode = (id) =>
  API.post(`/signup-codes/${encodeURIComponent(id)}/delete`);

export const getSignupCodeStats = ({ from, to } = {}) => {
  const params = new URLSearchParams();
  if (from) params.append("from", from);
  if (to) params.append("to", to);
  const qs = params.toString();
  return API.get(`/signup-codes/stats${qs ? `?${qs}` : ""}`);
};

export const getSignupCodeTimeseries = (codeId, { from, to } = {}) => {
  const params = new URLSearchParams({ code_id: codeId });
  if (from) params.append("from", from);
  if (to) params.append("to", to);
  return API.get(`/signup-codes/timeseries?${params.toString()}`);
};

/* Correlation id ties a pre-auth click to the eventual registration. */
export const getOrCreateCorrelationId = (existingId) => {
  if (existingId) return existingId;
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // RFC4122-ish fallback for older browsers
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
